module.exports = "/images/power.svg?8270a3bf6a668d3e6ab5fd75d2f1957d";